import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';
import { storeAsync } from '../../app-module';

const DocumentSeriesTypeList = () => import('@/modules/document-series-type/pages/DocumentSeriesTypeList.vue');

const getDocumentSeriesTypeModule = () => import('@/modules/document-series-type/document-series-type-store');
const importDocumentSeriesStore = () =>
    getDocumentSeriesTypeModule().then((storeModule) => {
        if (!storeAsync().hasModule('documentSeriesType')) storeAsync().registerModule('documentSeriesType', storeModule.default);
        else return;
    });

export default [
    {
        path: '',
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'documentSeriesType',
                path: '/document-series-type',
                component: DocumentSeriesTypeList,
                meta: {
                    auth: true,
                    permission: Permissions.values.documentSeriesTypeRead,
                },
                beforeEnter: (to, from, next) => {
                    importDocumentSeriesStore().then(() => {
                        next();
                    });
                },
            },
        ],
    },
];
